import { DeviceStateModel, RecoveryDeviceStatus } from '../../../data-access/gql-types/graphql';

export type DeviceType = {
  id: string;
  installationId: string;
  isUpdating: boolean;
  payload: DeviceStateModel;
  recoveryMode?: {
    status: RecoveryDeviceStatus;
    progress?: number;
  };
};

export enum DeviceModel {
  LavvaDouble = 'Lavva-Double',
  LavvaGate = 'Lavva-Gate',
  LavvaLed = 'Lavva-Led',
  LavvaPower = 'Lavva-Power',
  LavvaSwitch16A = 'Lavva-Switch16A',
  LavvaPlug = 'Lavva-Plug',
  LavvaTherm = 'Lavva-Therm',
  LavvaBlind = 'Lavva-Blind',
  LavvaSwitch = 'Lavva-Switch',
  SmartAWSC = 'smartAWSC',
  SmartAWMulti = 'smartAW-Multi',
  SmartAWGate = 'smartAW-Gate',
  SmartAWLed = 'smartAW-Led',
  LavvaEkoOzePv = 'Lavva-Eko-Oze-Pv',
  Atrom = 'ATROM-EM-485',
  LavvaSensHub = 'Lavva-Sensor-Hub',
  LavvaWallDuo = 'Lavva-Wall-Duo',
  SmartAWRoll = 'smartAW-Roll',
  LavvaUnity = 'Lavva-Unity',
  TauronPlug = 'Tauron-Lavva-Plug',
}
